// extracted by mini-css-extract-plugin
export default {"page":"Auth_page__VH0eP","card":"Auth_card__LShcr","cardForm":"Auth_cardForm__ZF1I5"};